import * as yup from 'yup'

export const createSchema = (setting) => yup.object().shape({
  title: yup.string()
    .required('Required field'),
  type: yup.string(),
  link: yup.string()
    .when('type', {
      is: 'link',
      then: yup.string()
        .required('Required field')
        .url('Please supply a valid URL beginning with http:// or https://')
    }),
  file: yup.mixed()
    .when('type', {
      is: 'file',
      then: yup.mixed()
        .required('Required field')
        .test('fileSizeLarge', 'File is too large', value => value && value.size <= setting.maxContentLength)
        .test('fileSizeSmall', 'File is too small', value => value && value.size >= setting.minContentLength)
    })
})
